<template>
  <layout>
    <AdminPageHeader :actions="actions" :header="$t('account.card.title')" />
    <div ref="content" class="content">
      <div class="row">
        <div v-for="(card, index) in cards" :key="index" class="col-lg-4">
          <div class="card border-left-3 border-left-danger rounded-left-0">
            <div class="card-body">
              <div class="d-sm-flex align-item-sm-center flex-sm-nowrap">
                <div>
                  <h6 class="font-weight-semibold">
                    **** **** **** {{ card.last4 }}ee
                  </h6>
                  <ul class="list list-unstyled mb-0">
                    <li>
                      {{ $t('account.card.funding') }}:
                      <a href="#">{{ card.funding }}</a>
                    </li>
                    <li v-if="card.address_zip">
                      {{ $t('account.card.zip') }}:
                      <span class="font-weight-semibold">
                        {{ card.address_zip }}
                      </span>
                    </li>
                  </ul>
                </div>

                <div class="text-sm-right mb-0 mt-3 mt-sm-0 ml-auto">
                  <h6 class="font-weight-semibold">{{ card.brand }}</h6>
                  <ul class="list list-unstyled mb-0">
                    <li>
                      {{ $t('account.card.country') }}:
                      <span class="font-weight-semibold">
                        {{ card.country }}
                      </span>
                    </li>
                    <li v-if="card.address_city">
                      {{ $t('account.card.city') }}:
                      <span class="font-weight-semibold">
                        {{ card.address_city }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              class="card-footer d-sm-flex justify-content-sm-between align-items-sm-center"
            >
              <span>
                <span class="badge badge-mark border-danger mr-2"></span>
                {{ $t('account.card.expiry_date') }}:
                <span class="font-weight-semibold">
                  {{ card.exp_month }}/{{ card.exp_year }}
                </span>
              </span>

              <ul class="list-inline list-inline-condensed mb-0 mt-2 mt-sm-0">
                <li class="list-inline-item">
                  <a href="#" class="text-default" @click="removeCard(card.id)">
                    <i class="icon-database-remove" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
  </layout>
</template>

<script>
import { AdminPageHeader } from 'stylemix-vue-admin'

const resourceBase = 'cards'

export default {
  components: {
    AdminPageHeader,
  },
  data() {
    return {
      actions: [
        {
          id: 'create',
          text: this.$t('account.card.add'),
          icon: 'icon-credit-card',
          onClick() {
            this.$router.push({
              name: `${resourceBase}.create`,
            })
          },
        },
      ],
      cards: [],
    }
  },

  mounted() {
    this.getCards()
  },

  methods: {
    getCards() {
      let promise = this.$http.get('cards').then(result => {
        this.cards = result.data.data
      })
      this.$uiBlocker(promise, this.$refs.content)
    },

    async removeCard(cardId) {
      const result = await this.$alert.question(
        this.$t('account.card.remove_confirm'),
        null,
        {
          showCancelButton: true,
        },
      )

      if (result.value) {
        let _promise = this.$http.delete('cards/' + cardId)
        this.$uiBlocker(_promise, this.$refs.content)
        _promise.then(result => {
          if (result.data.deleted) {
            this.cards = this.cards.filter(({ id }) => id !== cardId)
          }
        })
      }
    },
  },
}
</script>
